import { useMutation } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { sendToApi } from 'api/client'
import { FieldsetCompletion } from 'types'
import { buildErrorMessage } from 'utils'
import { UseMutationOptions } from 'react-query/types/react/types'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'

export interface Data {
  fieldset_completion: FieldsetCompletion
}

export interface Variables {
  completedFields: {
    [field: string]: any
  }
  generationType: string
  fields: Array<string>
  signal?: AbortSignal
}

export interface Options extends Omit<UseMutationOptions<Data, unknown, Variables>, 'mutationKey' | 'mutationFn'> {
  signal?: AbortSignal
}

export const useCreateFieldsetCompletion = (options?: Options) => {
  const currentWorkspaceId = useCurrentWorkspaceId()

  return useMutation<Data, unknown, Variables>(
    'createFieldsetCompletion',
    async ({ generationType, fields, completedFields, signal }) => {
      const response = await sendToApi<Data>(`/w/${currentWorkspaceId}/fieldset_completions`, {
        method: 'POST',
        body: {
          generation_type: generationType,
          fields,
          completed_fields: completedFields,
        },
        signal,
      })
      if (response.type !== SUCCESS_RESPONSE_TYPE) {
        throw new Error(
          buildErrorMessage(response.data.errors) ||
            'An error occurred! Our team has been notified and we are looking into it.',
        )
      }
      return response.data
    },
    {
      ...options,
    },
  )
}
